module.exports = __webpack_public_path__ + "static/img/2017@2x.78a4292.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2017@2x.png
// module id = 18Gm
// module chunks = 1